/**
 * 提示语轮播逻辑
 */
import { TIPS } from '../utils/constants';

export function useTips() {
  let tipTimer = null;
  let currentTipIndex = 0;

  return {
    /**
     * 开始提示语轮播
     * @param {Function} onTipChange - 提示语变化回调 (index) => void
     * @param {number} interval - 轮播间隔（毫秒），默认 5000
     */
    startTipsRotation(onTipChange, interval = 5000) {
      currentTipIndex = Math.floor(Math.random() * TIPS.length);
      if (typeof onTipChange === 'function') {
        onTipChange(currentTipIndex);
      }

      tipTimer = setInterval(() => {
        currentTipIndex = (currentTipIndex + 1) % TIPS.length;
        if (typeof onTipChange === 'function') {
          onTipChange(currentTipIndex);
        }
      }, interval);
    },

    /**
     * 停止提示语轮播
     */
    stopTipsRotation() {
      if (tipTimer) {
        clearInterval(tipTimer);
        tipTimer = null;
      }
    },

    /**
     * 获取当前提示语
     */
    getCurrentTip() {
      return TIPS[currentTipIndex];
    },

    /**
     * 获取所有提示语
     */
    getTips() {
      return TIPS;
    }
  };
}
